export default "__VITE_ASSET__Bejirc2D__"